<template>
  <div class="report-period-selector">
    <strong>Report Period</strong>
    <q-option-group
      :model-value="periodType"
      :options="periodOptions"
      type="radio"
      @update:model-value="$emit('update:periodType', $event)"
    />

    <template v-if="periodType === 'month'">
      <strong>Month</strong>
      <q-input
        :model-value="month"
        label="Month"
        stack-label
        type="month"
        bg-color="white"
        outlined
        dense
        style="width: 50%"
        @update:model-value="$emit('update:month', $event)"
      />
    </template>

    <template v-if="periodType === 'custom'">
      <strong>Date range</strong>
      <div class="row full-width q-gutter-r-md q-mb-lg items-center">
        <q-input
          :model-value="startDate"
          label="Start date"
          stack-label
          type="date"
          bg-color="white"
          outlined
          dense
          class="col-6"
          @update:model-value="$emit('update:startDate', $event)"
        />

        <q-input
          :model-value="endDate"
          label="End date"
          stack-label
          type="date"
          dense
          bg-color="white"
          outlined
          class="col-6"
          @update:model-value="$emit('update:endDate', $event)"
        />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ReportPeriodSelector",
  props: {
    periodType: {
      type: String,
      required: true
    },
    periodOptions: {
      type: Array,
      required: true
    },
    month: {
      type: String,
      required: false
    },
    startDate: {
      type: String,
      required: false
    },
    endDate: {
      type: String,
      required: false
    }
  },
  emits: [
    "update:periodType",
    "update:month",
    "update:startDate",
    "update:endDate"
  ]
}
</script>

<style lang="css" scoped>
.report-period-selector {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
</style>
